import { combineReducers } from "redux";
import marginCalculator from "./MarginCalculator/Reducers/MarginCalculator";
export default combineReducers({
    marginCalculator,
});
